<template>
  <div>
    <page-heading-info
    title="Jefferson County Regional Planning Commission"
    phone="(740) 283-8568"
    fax="(740) 283-8656"
    >
      <address-simple
      line1="500 Market Street"
      line2="Suite 520"
      line3="Steubenville, Ohio 43952"
      ></address-simple>
    </page-heading-info>

    <text-box-title class="mt-3" title="Meeting Schedule">
      <note-text note-id="53" class="ml-3 mr-3 mt-3"></note-text>
    </text-box-title>

    <!-- <text-box-title class="mt-3" title="PUBLIC NOTIFICATION">
      <note-text note-id="56" class="ml-3 mr-3 mt-3"></note-text>
    </text-box-title> -->

    <text-box-title class="mt-3" title="Documents">
      <note-documents note-id="43" class="ml-3 mr-3 mt-3"></note-documents>
    </text-box-title>

    <text-box-title title="Staff" class="mt-3">
      <div class="col-md-4 pl-4">
        <!-- staff member -->
        <div class="clear-list mt-4">
          <ul>
            <li><h4><u>Director</u></h4></li>
            <li>Betty Lou Tarr</li>
            <li>500 Market Street, Suite 520</li>
            <li>Steubenville, Ohio 43952</li>
            <li>Phone: 740-283-8568</li>
            <li>Fax: 740-283-8656</li>
            <li><a href="mailto:bettylou@jeffersoncountyoh.com">bettylou@jeffersoncountyoh.com</a></li>
          </ul>
        </div>
      </div>

      <div class="col-md-4 pl-4">
        <!-- staff member -->
        <div class="clear-list mt-4">
          <ul>
            <li><h4><u>Administrative Assistant</u></h4></li>
            <li>Allie Shuble</li>
            <li>500 Market Street, Suite 520</li>
            <li>Steubenville, Ohio 43952</li>
            <li>Phone: 740-283-8568</li>
            <li>Fax: 740-283-8656</li>
            <li><a href="mailto:ashuble@jeffersoncountyoh.com">ashuble@jeffersoncountyoh.com</a></li>
          </ul>
        </div>
      </div>

      <div style="text-align: center; width: 100%; font-size: large; padding-top: 1rem; font-weight: bold;">
        The local Fair Housing contact is Betty Lou Tarr (740-283-8568).
      </div>
    </text-box-title>

    <text-box-title class="mt-3" title="Meeting Minutes Downloads">
      <note-documents note-id="38" class="ml-3 mr-3 mt-3"></note-documents>
    </text-box-title>
  </div>
</template>

<script>
import PageHeadingInfo from '@/components/layout/PageHeadingInfo.vue'
import AddressSimple from '@/components/display-utils/AddressSimple.vue'
import TextBoxTitle from '@/components/layout/TextBoxTitle.vue'
import LinkBox from '@/components/layout/LinkBox.vue'
import NoteDocuments from '@/components/display-utils/NoteDocuments.vue'
import NoteText from '@/components/display-utils/NoteText.vue'

export default {
  components: {
    PageHeadingInfo,
    AddressSimple,
    TextBoxTitle,
    LinkBox,
    NoteDocuments,
    NoteText
  },
  data () {
    return {}
  }
}
</script>

<style>
</style>
